import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import React, {useContext} from "react";
import {UnpaidWorkContext} from "../../context/unpaid_work";
import dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function UnpaidWorkForm() {

  const {
    unpaidWork,
    setOpen,
    open,
  } = useContext(UnpaidWorkContext);

  const handleOpen = () => setOpen(!open);

  if (unpaidWork) {
    return (
      <>
        <Dialog open={open} handler={handleOpen}
                animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            <Typography>پرداخت / تسویه</Typography>
          </DialogHeader>
          <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

            <div className="grid grid-cols-1 gap-4">

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("user")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${unpaidWork.person_name}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("user_phone")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${persianNumberFormat(unpaidWork.person_phone)}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("agent")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${unpaidWork.agent_name}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("agent_phone")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${persianNumberFormat(unpaidWork.agent_phone)}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("branch_title")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${unpaidWork.branch_name}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("step")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${persianNumberFormat(unpaidWork.step)}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("title")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${unpaidWork.step_title}`}
                  </Typography>
                </div>
              </div>

              <div
                className="grid grid-row justify-around max-w-full grid-cols-2 text-nowrap mt-2 border-b pb-2"
              >
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray">
                    {`${dict("description")}:`}
                  </Typography>
                </div>
                <div className="grid grid-col min-w-fit">
                  <Typography color="blue-gray" variant="h6">
                    {`${unpaidWork.step_description}`}
                  </Typography>
                </div>
              </div>

            </div>

          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
          </DialogFooter>
        </Dialog>
      </>
    );
  }
}